var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./base.service";
export class CartService extends BaseService {
    constructor(ellCommerce) {
        super(ellCommerce, "cart");
    }
    createCart(userId, items, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const iso2 = this.getCountryISO2(countryISO2);
                const response = yield this.api.request({
                    url: `carts/user/${userId}/country/${iso2}`,
                    method: "POST",
                    data: items,
                });
                this.pushGtagEvent({ action: "view_item", cart: response.data, cartItems: items });
                this.pushGtagEvent({ action: "add_to_cart", cart: response.data, cartItems: items });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    addCartItem(cartId, item) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `carts/${cartId}/items`,
                    method: "POST",
                    data: item,
                });
                this.pushGtagEvent({ action: "view_item", cart: response.data, cartItems: [item] });
                this.pushGtagEvent({ action: "add_to_cart", cart: response.data, cartItems: [item] });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    updateCartItem(cartId, itemId, item) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `carts/${cartId}/items/${itemId}`,
                    method: "PUT",
                    data: item,
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getCartByUser(userId, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const response = yield this.api.request({
                    url: `carts/user/${userId}/country/${iso2}`,
                    method: "GET",
                });
                this.pushGtagEvent({ action: "view_cart", cart: response.data });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getCartsByUser(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `carts/user/${userId}`,
                    method: "GET",
                });
                const carts = response.data;
                if (carts && carts.length > 0) {
                    this.pushGtagEvent({ action: "view_cart", cart: carts[0] });
                }
                return carts;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getCart(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `carts/${cartId}`,
                    method: "GET",
                });
                this.pushGtagEvent({ action: "view_cart", cart: response.data });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getRedirectUrls(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `carts/${cartId}/redirectUrls`,
                    method: "GET",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    deleteCart(cartId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.api.request({
                    url: `carts/${cartId}`,
                    method: "DELETE",
                });
                this.pushGtagEvent({ action: "remove_from_cart", cartId: cartId });
                return true;
            }
            catch (e) {
                this.handleError(e);
                return false;
            }
        });
    }
    deleteCartItem(cartId, itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `carts/${cartId}/items/${itemId}`,
                    method: "DELETE",
                });
                this.pushGtagEvent({ action: "remove_from_cart", cartId: cartId, cartItemId: itemId });
                if (!(response === null || response === void 0 ? void 0 : response.data)) {
                    return null;
                }
                else {
                    return response.data;
                }
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    applyCoupon(cartId, couponCode) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `carts/${cartId}/coupon`,
                    method: "POST",
                    data: couponCode,
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    removeCoupon(cartId, couponCode) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.api.request({
                    url: `carts/${cartId}/coupon/${couponCode}`,
                    method: "DELETE",
                });
                return response.data;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
    getCheckoutUrl(userId, cartId, countryISO2) {
        return __awaiter(this, void 0, void 0, function* () {
            const iso2 = this.getCountryISO2(countryISO2);
            try {
                const redirectUrls = yield this.getRedirectUrls(cartId);
                const response = yield this.ellCommerce.CustomerService().getLoginSSOUrl(userId, iso2, redirectUrls.checkoutUrl);
                return response;
            }
            catch (e) {
                this.handleError(e);
                return null;
            }
        });
    }
}
